import script from "./ChatPreloader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPreloader.vue?vue&type=script&setup=true&lang=js"

import "./ChatPreloader.vue?vue&type=style&index=0&id=28bf7aca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bf7aca"]])

export default __exports__